import { isEmpty } from "lodash";
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { RoutingContext } from "src/contexts";
import { Routes } from "src/routes";
import { Storage } from "src/services";

type Props = {
  component: React.ElementType;
  title?: string;
  subtitle?: string;
};

const PrivateRoute: React.FC<Props> = ({ title, subtitle, component: Component, ...rest }) => {
  const token = Storage.getToken();
  const { setTitle, setSubtitle } = useContext(RoutingContext);

  if (title) setTitle(title);
  if (subtitle) setSubtitle(subtitle);

  if (!isEmpty(token)) return <Component {...rest} />;
  return (
    <Navigate
      to={{
        pathname: Routes.LOGIN,
      }}
    />
  );
};

export default PrivateRoute;
